import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47bc3644"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "State Changes", -1))
const _hoisted_4 = ["label"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "dialog-footer" }

import { ref } from "vue";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryRecord',
  setup(__props, { expose: __expose }) {

const dialogRef = ref(false);
const id = ref<any>(null);
const isLoading = ref(false);
const dialogData = ref<any>([]);
const fecthData = async () => {
  isLoading.value = true;
  try {
    const response = await PaymentService.getStateDetail(id.value);
    dialogData.value = response;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const show = async (_id) => {
  dialogRef.value = true;
  id.value = _id;
  await fecthData();
};

const close = () => {
  dialogRef.value = false;
  id.value = null;
  dialogData.value = [];
  isLoading.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogRef).value = $event)),
    width: "1200",
    "align-center": "",
    "before-close": close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogRef.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_LoadingRing)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value.stateChanges, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_component_el_descriptions, {
                  column: 2,
                  border: "",
                  class: "mb-8"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (data, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        label: i
                      }, [
                        _createVNode(_component_el_descriptions_item, {
                          label: i,
                          "label-width": "100px"
                        }, {
                          default: _withCtx(() => [
                            (i == 'performedOn')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  _createVNode(_component_TimeShow, { "date-iso-string": data }, null, 8, ["date-iso-string"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(data), 1))
                          ]),
                          _: 2
                        }, 1032, ["label"])
                      ], 8, _hoisted_4))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128)),
            _createVNode(_component_el_descriptions, {
              column: 2,
              border: "",
              title: "Callback",
              class: "mt-5"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value.callbackBody, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    (index != 'body')
                      ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                          key: 0,
                          label: index
                        }, {
                          default: _withCtx(() => [
                            (index == 'updatedOn')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createVNode(_component_TimeShow, { "date-iso-string": item }, null, 8, ["date-iso-string"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item), 1))
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})